import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN, PRODUCTION } from '@/store/constants';

export default {
    install(Vue) {
        if (!PRODUCTION) return;

        mixpanel.init(MIXPANEL_TOKEN, {
            persistence: 'localStorage',
            loaded: function (mixpanel) {
                console.log('Mixpanel loaded. Version:', mixpanel.get_config('token'));
            },
        });
        Vue.prototype.$mixpanel = mixpanel;
    },
};